import { Component, OnInit } from "@angular/core";
import { BaseComponent } from "../../base.component";
import { NgxSpinnerService } from "ngx-spinner";
import { CommonMessages } from "src/app/shared/messages/messages.enum";
import { CampaignBuilderService } from "src/app/services/segmentation/campaign-builder.service";
import { ClientService } from "src/app/services/clients/client.service";

@Component({
  selector: "app-prompt-list",
  templateUrl: "./prompt-list.component.html",
  styleUrls: ["./prompt-list.component.scss"],
})
export class PromptListComponent extends BaseComponent implements OnInit {

  currentUser: any = null;
  companyID: number = 0;
  promptObj: any = [];
  promptStatusObj: any = [{name: 'Active', value: true},{name: 'Inactive', value: false}];
  getJourneyObj: any = [];
  promptStatusVal: boolean = true;
  totalCount: number = 0;
  page: number = 1;
  limit:number = 10;
  skip:number = 0;
  expandedRows: { [key: string]: boolean } = {};

  constructor(
    private spinner: NgxSpinnerService,
    private campaignBuilderService: CampaignBuilderService,
    private clientService: ClientService,
  ) {
    super();
  }

  ngOnInit() {
    this.getCompany();
    this.currentUser = JSON.parse(sessionStorage.getItem("userData")!);
  }

  getCompany() {
    let self = this;
    this.clientService.getBUCompanies().subscribe(
      (data) => {
        self.getJourneyObj = data.data;
        self.hydrateWorkingCompany(self, (id) => { self.onCompanyChange({ target: { value: id }, value: id }); });

        this.getJourneyObj = this.getJourneyObj.sort((a, b) => {
          return a.customer_company_name.localeCompare(b.customer_company_name);
        });
        if(this.getJourneyObj.length > 0 && this.companyID){
          this.getPromptListData(this.companyID);
        }
      },
      (error) => {},
    );
  }

  getPromptListData(cid: any){
    let self = this;
    this.skip = (this.page - 1) * this.limit;
    this.spinner.show();
    this.campaignBuilderService.getPromptRecords(cid,this.limit,this.skip,this.promptStatusVal).subscribe((data) => {
        if (data.status) {
          if (data.data.rows == null) {
            self.promptObj = [];
          } else {
            self.promptObj = data.data.rows;
            console.log(this.promptObj);
          }
          self.totalCount = data.data.total;
        } else {
          self.promptObj = [];
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      },
    );
  }

  onStatusChange(obj: any, type: any) {
    let previousStatus, is_enabled;
    
    if (type === 'ds') {
      previousStatus = obj.is_ds_enabled;
      is_enabled = !obj.is_ds_enabled;
    } else {
      previousStatus = obj.is_active;
      is_enabled = !obj.is_active;
    }

    if (type === 'ds') {
      obj.is_ds_enabled = is_enabled;
    } else {
      obj.is_active = is_enabled;
    }

    let payload: any = {
      id : obj.id,
    }

    if (type === 'ds') {
      payload['is_ds_enabled'] = is_enabled;
    } else {
      payload['is_active'] = is_enabled;
    }
    this.spinner.show();
    this.campaignBuilderService.updateStatus(this.companyID, payload).subscribe((data: any) => {
        if (data.status) {
          this.getPromptListData(this.companyID);
          this.toastrService.success(data.message);
        } else {
          if (type === 'ds') {
            obj.is_ds_enabled = previousStatus;
          } else {
            obj.is_active = previousStatus;
          }
          this.toastrService.success(data.message);
        }
        this.spinner.hide();
      },
      (error) => {
        if (type === 'ds') {
          obj.is_ds_enabled = previousStatus;
        } else {
          obj.is_active = previousStatus;
        }
      }
    );
  }

  onCompanyChange(event:any){
    this.companyID = Number((event.target as HTMLSelectElement).value);
    this.getPromptListData(this.companyID)
  }

  onStatusFilterChange(event: any){
    this.getPromptListData(this.companyID)
  }

  deletePromptRecord(id: any) {
    this.confirmationDialogService
      .confirm(
        CommonMessages.confirmationTitle,
        CommonMessages.deleteConfirmation,
        "Yes",
        "No",
      )
      .then((confirmed) => {
        if (confirmed) {
          this.spinner.show();
          const payload = {
            id : id,
            is_deleted : true
          }
          this.spinner.show();
          this.campaignBuilderService.updateStatus(this.companyID, payload).subscribe((data: any) => {
              if (data.status) {
                this.getPromptListData(this.companyID);
                this.toastrService.success(data.message);
              } else {
                this.toastrService.success(data.message);
              }
              this.spinner.hide();
            },
            (error) => {

            }
          );
        }
      })
      .catch(() => console.log(CommonMessages.dialogDismissMessage));
  }

  toggleExpand(id: string): void {
    this.expandedRows[id] = !this.expandedRows[id];
  }

  isExpanded(id: string): boolean {
    return !!this.expandedRows[id];
  }

  getCompanyData(page: number) {
    this.page = page;
    this.getPromptListData(this.companyID);
  }

}
